import {
  parseAsBoolean,
  parseAsString,
  useQueryState,
} from '@vrplatform/query-params';
import { removeDrawerStateFromUrl } from '../../utils';

export function useAddTeamDrawer() {
  const [opened, setOpened] = useQueryState('add-team-drawer', parseAsBoolean);
  const [teamName, setTeamName] = useQueryState('add-team-name', parseAsString);

  return {
    opened: !!opened,
    teamName,
    open: (teamName?: string) => {
      removeDrawerStateFromUrl();
      setTeamName(teamName || null);
      setOpened(true);
    },
    close: () => {
      setOpened(false);
      setTeamName(null);
    },
  };
}
